import { Box } from "@chakra-ui/react";
import CDS from "design-system";
import moment from "moment-timezone";

interface LocalTimeLabelsProps {
  columnTimezone: string;
  schedulingTimezone: string;
  date: Date;
  slotHeight: number;
  hours: number[];
}

export default function LocalTimeLabels({
  columnTimezone,
  schedulingTimezone,
  date,
  slotHeight,
  hours,
}: LocalTimeLabelsProps) {
  return (
    <Box position="absolute" top={0} left={0} right={0} bottom={0} pointerEvents="none">
      {hours
        .filter((h) => h % 2 === 0)
        .map((h) => {
          const localTime = moment.tz(date, schedulingTimezone)
            .set({ hour: h, minute: 0 })
            .clone()
            .tz(columnTimezone);
          return (
            <CDS.Text10
              key={h}
              position="absolute"
              top={`${h * slotHeight + 2}px`}
              left="2px"
              fontSize="2xs"
              color="gray.400"
              lineHeight="1"
              userSelect="none"
            >
              {localTime.format("h A")}
            </CDS.Text10>
          );
        })}
    </Box>
  );
}
